
import { Component } from 'vue-property-decorator';

import RemoteDataTable, {
  RemoteDataField
} from '@/components/RemoteDataTable.vue';

import MenuGroupAddEdit from '@/views/DashView/MenuGroup/MenuGroupAddEdit.vue';
import { getResponseToMTH } from '@/utils/helpers';
import constants from '@/utils/constants';

class MenuGroupItem {
  id: string = '';
  outletCode: string = '';
  menuGroupCode: string = '';
  sequence: number = 0;
}

@Component({
  components: {
    editor: MenuGroupAddEdit
  }
})
export default class MenuGroupList extends RemoteDataTable<MenuGroupItem> {
  public pageTitle: string = 'Menu Group List';

  public newButtonText: string = 'New Menu Group';

  public fieldsSet: Array<RemoteDataField> = [
    new RemoteDataField({ key: 'index', label: '', sortable: false }),
    new RemoteDataField({ key: 'action', label: '', sortable: false }),

    new RemoteDataField({ key: 'outletCode', label: 'Outlet Code' }),
    new RemoteDataField({ key: 'outletName', label: 'Outlet Name' }),
    new RemoteDataField({ key: 'menuGroupCode', label: 'Menu Group Code' }),
    new RemoteDataField({ key: 'name', label: 'Menu Group Name' }),
    new RemoteDataField({ key: 'sequence', label: 'Sequence' })
  ];
  // to get page data
  get items(): MenuGroupItem[] {
    return this.$store.getters.GetAllMenuGroup;
  }

  get paging(): MenuGroupItem[] {
    return this.$store.getters.PagingMenuGroup;
  }

  get sorting(): MenuGroupItem[] {
    return this.$store.getters.SortingMenuGroup;
  }

  get filtering(): MenuGroupItem[] {
    return this.$store.getters.FilteringMenuGroup;
  }

  sortingChanged(ctx) {
    this.$store.dispatch('UpdateSortingMenuGroup', {
      byField: ctx.sortBy,
      isDesc: ctx.sortDesc
    });
  }

  filterChanged(isResetFilter) {
    this.$store.dispatch('UpdateFilteringMenuGroup', {
      isResetFilter: isResetFilter
    });
  }

  reload(id = null) {
    if (id === 1) {
      this.$store.state.menuGroup.pagingMenuGroup.page = 1;
    }
    this.$store.dispatch('GetAllMenuGroup');
  }

  // delete item
  deleteItem(item) {
    this.$swal({
      title: constants.ARE_YOU_SURE,
      text: constants.CONFIRM_DELETE_ITEM,
      icon: constants.STATUS_WARNING,
      buttons: true,
      dangerMode: true
    }).then(willDelete => {
      if (willDelete) {
        this.$store
          .dispatch('DeleteMenuGroup', item.id)
          .then(response => {
            getResponseToMTH(response, this.$swal, constants.RECORD_IS_DELETED);
          })
          .catch(error => {
            this.$swal(
              constants.SOMETHING_WROING,
              error.response.data.message,
              constants.STATUS_ERROR
            );
          });
      }
    });
  }

  setPerPage(page) {
    this.$store.state.menuGroup.pagingMenuGroup.size = page;
    this.$store.dispatch('GetAllMenuGroup');
  }
}
